import { render, staticRenderFns } from "./DefaultLayout.vue?vue&type=template&id=0a8a0082"
var script = {}
import style0 from "./DefaultLayout.vue?vue&type=style&index=0&id=0a8a0082&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports